import type { DataTableSortDirection } from '@enamelai/design-system'

export const handleChartHistoryTableSort = (
  columnId: string,
  sortColumnId: string | null,
  sortDirection: DataTableSortDirection,
  setSortColumnId: (value: string | null) => void,
  setSortDirection: (value: DataTableSortDirection) => void,
  setCurrentPage: (value: number) => void,
): void => {
  if (sortColumnId !== columnId) {
    setSortColumnId(columnId)
    setSortDirection('asc')
  } else if (sortDirection === 'asc') {
    setSortDirection('desc')
  } else {
    setSortColumnId(null)
    setSortDirection('asc')
  }
  setCurrentPage(1)
}

export const compareChartHistorySortValues = (
  a: string | number,
  b: string | number,
  direction: DataTableSortDirection,
): number => {
  const mult = direction === 'asc' ? 1 : -1
  if (typeof a === 'number' && typeof b === 'number') {
    return (a - b) * mult
  }
  return (
    String(a).localeCompare(String(b), undefined, { sensitivity: 'base' }) *
    mult
  )
}
